import script from "./OrganizationContractRemoveServiceProviderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractRemoveServiceProviderModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractRemoveServiceProviderModal.vue?vue&type=style&index=0&id=07bf2caf&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07bf2caf"]])

export default __exports__